import { useQuery } from '@tanstack/react-query';
import { IStatsResponse } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetDashboardStats = () => useQuery({
  queryKey: ['get_all_dashboard_data'],
  queryFn: async (): Promise<IStatsResponse> => {
    const res = await apiClient.get(ENDPOINTS.DASHBOARD.GET_ALL_STATS);
    return res.data;
  }
})